import { useTranslation } from 'react-i18next';

import { TextWithIcon } from '@/ui';

export type CallerImagePreviewComponentProps = {
  isSending: boolean;
};

export function CallerImagePreviewComponent({ isSending }: CallerImagePreviewComponentProps) {
  const { t } = useTranslation();

  if (!isSending) {
    return null;
  }

  return (
    <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-white border border-1 border-dark border-dashed">
      <div className="x-small text-muted fa-fade">
        <TextWithIcon icon="fal fa-message-image" text={t('Chat_CallerIsSendingImage')} />
      </div>
      <div
        className="image-preview m-2 rounded-3 bg-body-secondary d-flex align-items-center justify-content-center text-black-50"
        style={{ height: '100px', maxWidth: '-webkit-fill-available', width: '100%' }}
      >
        <i className="fa-regular fa-image fa-2xl"></i>
      </div>
    </div>
  );
}
